module.exports = {"name":null,"type":null,"phone":null,"filingDate":null,"dateOfIncorporation":null,"tin":null,"partnership":[],"partnershipPercentage":null,"businessAddress":{"address":null,"unit":null,"city":null,"state":null,"zipCode":null},"sameAddress":true,"mailingAddress":{"address":null,"unit":null,"city":null,"state":null,"zipCode":null},"associatedEntities":[]}


//////////////////
// WEBPACK FOOTER
// ./src/components/entities/resources/entity.json
// module id = eg1t
// module chunks = 1